export enum LoaderMessageType {
  LoadProjectValues,
  StoreProjectValues,
  DeleteProjectValues,
  GetFilesList,
  SynchronisingProjectValues,
  StartingAzureFunction,
}
